<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      RecordExpense(:step.sync="step" :open.sync="showModal" @proceed="updateExpense" :loading="isLoading")

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RecordExpense from './RecordExpense.vue'

export default {
  name: 'AddExpenseDialog',
  components: { RecordExpense },
  props: ['open'],
  data: () => ({
    step: 0,
    isLoading: false,
    data: {
      expense: null,
      payment: null,
      document: null
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    updateExpense (val) {
      this.data = val
      this.saveTransaction()
    },
    saveTransaction () {
      this.isLoading = true
      this.$axios.post(`/books/${this.company.slug}/expenses/`, this.data.expense)
        .then(resp => {
          const expensePid = resp.data.id
          this.$axios.get(`/books/${this.company.slug}/expenses/${expensePid}/?expand=vendor,category,items`)
            .then(resp => {
              const expense = resp.data
              if (this.data.payment && this.data.payment.payment_method) {
                if (expense.amount_remaining <= this.data.payment.amount) {
                  expense.payment_status = 'paid'
                }
                this.$axios.post(`/books/${this.company.slug}/expenses/${expense.id}/payments`, this.data.payment)
                  .then(() => {
                    this.showMessage(['success', this.$t('success_message.expense_recorded_successfully')])
                    this.$axios.get(`/books/${this.company.slug}/expenses/${expensePid}/?expand=vendor,category,items`)
                      .then(resp => {
                        const expense = resp.data
                        this.$emit('added', expense)
                        this.showModal = false
                        this.isLoading = false
                      })
                  })
                  .catch(() => {
                    this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                  })
              } else {
                this.$emit('added', expense)
                this.showModal = false
                this.isLoading = false
              }
              if (this.data.document) {
                var params = new FormData()
                params.set('doc_type', this.data.document.doc_type)
                params.set('file', this.data.document.file)
                this.$axios.post(`/books/${this.company.slug}/expenses/${expense.id}/documents?doc_type=${this.data.document.doc_type}`, params).catch(() => {})
              }
            }).catch(() => {})
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "proceed": "Proceed"
  }
}
</i18n>
